import { render, staticRenderFns } from "./InviteCollaborator.vue?vue&type=template&id=40ec932f&scoped=true"
import script from "./InviteCollaborator.vue?vue&type=script&lang=js"
export * from "./InviteCollaborator.vue?vue&type=script&lang=js"
import style0 from "./InviteCollaborator.vue?vue&type=style&index=0&id=40ec932f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ec932f",
  null
  
)

export default component.exports